export default __webpack_public_path__ + "static/media/complementary--railroad--g3.3ee9fe34.png";